import { SliceCaseReducers } from '@reduxjs/toolkit'
import { createOperationSlice, GenericOperationState } from '@repo/core'
interface GenerateCatalogSliceParams {
  domain: string
  namespace: string
}

export const generateCatalogSlice = <Configuration>({
  domain,
  namespace,
}: GenerateCatalogSliceParams) => {
  const initialState: GenericOperationState<Configuration> = {
    payload: {} as Configuration,
    meta: { fetchState: 'initial' },
    error: false,
  }
  return createOperationSlice<
    Configuration,
    SliceCaseReducers<GenericOperationState<Configuration>>,
    { domain: string }
  >({
    name: `@catalogs/${domain}/${namespace}`,
    initialState,
    reducers: {},
  })
}
